import React, { useEffect, useState } from 'react';
import { Card, Table, Button, Space, Modal, Form, Input, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import roomService, { RoomDto } from '../../services/roomService';

const RoomManagementPage: React.FC = () => {
  const [data, setData] = useState<RoomDto[]>([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState<RoomDto | null>(null);
  const [form] = Form.useForm<RoomDto>();

  async function load() {
    setLoading(true);
    try {
      const res = await roomService.list({ limit: 1000 });
      setData(res.data || []);
    } catch (e) {
      message.error('Không tải được danh sách phòng học');
    } finally { setLoading(false); }
  }

  useEffect(() => { load(); }, []);

  function openCreate() {
    setEditing(null);
    form.resetFields();
    setModalOpen(true);
  }

  function openEdit(record: RoomDto) {
    setEditing(record);
    form.setFieldsValue(record);
    setModalOpen(true);
  }

  async function onSubmit() {
    try {
      const values = await form.validateFields();
      if (editing?.RoomID) {
        await roomService.update(editing.RoomID, values);
        message.success('Cập nhật phòng học thành công');
      } else {
        await roomService.create(values);
        message.success('Tạo phòng học thành công');
      }
      setModalOpen(false);
      load();
    } catch {}
  }

  async function onDelete(record: RoomDto) {
    Modal.confirm({
      title: 'Xóa phòng học?',
      content: `${record.TenPhongHoc} (${record.PhongHocID})`,
      onOk: async () => {
        await roomService.remove(record.RoomID!);
        message.success('Đã xóa');
        load();
      }
    });
  }

  return (
    <Card title="Quản lý Phòng học" extra={<Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>Thêm phòng học</Button>}>
      <Table
        rowKey={(r) => String(r.RoomID || r.PhongHocID)}
        dataSource={data}
        loading={loading}
        pagination={false}
        columns={[
          { title: 'Mã phòng', dataIndex: 'PhongHocID', key: 'PhongHocID' },
          { title: 'Tên phòng học', dataIndex: 'TenPhongHoc', key: 'TenPhongHoc' },
          { title: 'Tòa nhà', dataIndex: 'ToaNha', key: 'ToaNha' },
          { title: 'Mô tả', dataIndex: 'MoTa', key: 'MoTa' },
          {
            title: 'Hành động', key: 'actions', render: (_, record) => (
              <Space>
                <Button icon={<EditOutlined />} size="small" onClick={() => openEdit(record)} />
                <Button icon={<DeleteOutlined />} danger size="small" onClick={() => onDelete(record)} />
              </Space>
            )
          }
        ]}
      />

      <Modal
        title={editing ? 'Cập nhật phòng học' : 'Thêm phòng học'}
        open={modalOpen}
        onOk={onSubmit}
        onCancel={() => setModalOpen(false)}
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item name="PhongHocID" label="Mã phòng học" rules={[{ required: true, message: 'Nhập mã phòng học' }]}>
            <Input maxLength={50} />
          </Form.Item>
          <Form.Item name="TenPhongHoc" label="Tên phòng học" rules={[{ required: true, message: 'Nhập tên phòng học' }]}>
            <Input maxLength={100} />
          </Form.Item>
          <Form.Item name="ToaNha" label="Tòa nhà">
            <Input maxLength={100} />
          </Form.Item>
          <Form.Item name="MoTa" label="Mô tả">
            <Input maxLength={255} />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default RoomManagementPage;


